import { createContext, useContext } from 'react';

import { DiagramColors } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/hooks/useDiagramColors';

interface DiagramContextValue {
  colors: DiagramColors;
  markerId: string;
}

const DiagramContext = createContext<DiagramContextValue | null>(null);

export const DiagramContextProvider = DiagramContext.Provider;

export const useDiagramContext = () => {
  const diagram = useContext(DiagramContext);
  if (!diagram) {
    throw new Error('Diagram pieces must be rendered inside <Diagram>');
  }

  return diagram;
};
